module.exports = __webpack_public_path__ + "img/pl.872ed706.svg";